import React from 'react';
import { Box, Grid, CircularProgress, Alert } from '@mui/material';
import { useAnalyticsData } from '../../hooks/useAnalyticsData';
import {
  DashboardHeader,
  SummaryCards,
  WeeklyTransactionChart,
  ContentTypeChart,
  TransactionStatusChart,
  ViolationsByPolicyChart,
} from './AnalyticsDashboardComponents';

const AnalyticsDashboard = () => {
  const { data: stats, loading, error, refresh } = useAnalyticsData();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <DashboardHeader onRefresh={refresh} loading={loading} />
      <SummaryCards stats={stats} />

      {/* Charts - 2x2 Grid */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <WeeklyTransactionChart stats={stats} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ContentTypeChart stats={stats} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TransactionStatusChart stats={stats} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ViolationsByPolicyChart stats={stats} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AnalyticsDashboard;
